module.exports = __webpack_public_path__ + "img/profileSettingRe.6539ea8e.svg";